export const environment = {
  production: true,
  version: require('../../package.json').version,
  platform: 'uat',
  appInsights: {
    instrumentationKey: 'd2fbd847-7871-4355-88be-ca89b6113e40',
    connectionString:
      'InstrumentationKey=d2fbd847-7871-4355-88be-ca89b6113e40;IngestionEndpoint=https://southafricanorth-1.in.applicationinsights.azure.com/;LiveEndpoint=https://southafricanorth.livediagnostics.monitor.azure.com/;ApplicationId=f459f422-bc58-4e2e-966e-1e8a357fa4be',
    enableApplicationInsights: false
  },
  API_URL: 'https://uatapi.mxnodeapp.co.za/v2/',
  PRIVACY_POLICY_URL: 'https://www.paydoc.co.za/privacy-policy/'
};
